import React from 'react'
import { Grid } from '@material-ui/core'
import { Container } from '../../../Container'
import { useTemplateScheduleGanttStyles } from '../../styles'

interface Props {
    unitCount: number
    serviceAreaCount: number
}

export const ServiceDetailHeader = (props: Props) => {
    const { unitCount, serviceAreaCount } = props
    const classes = useTemplateScheduleGanttStyles()

    return (
        <Grid container item xs={12} className={classes.serviceDetailHeader}>
            <Grid item xs={6}>
                <Container
                    style={{
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }}
                >
                    <span className={classes.serviceDetailHeaderTitle}>
                        Units
                    </span>
                    <span className={classes.serviceDetailHeaderValue}>
                        {unitCount}
                    </span>
                </Container>
            </Grid>

            <Grid item xs={6}>
                <Container className={classes.serviceDetailHeaderContent}>
                    <span className={classes.serviceDetailHeaderTitle}>
                        Service Areas
                    </span>
                    <span className={classes.serviceDetailHeaderValue}>
                        {serviceAreaCount}
                    </span>
                </Container>
            </Grid>
        </Grid>
    )
}
